import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles, createStyleSheet } from 'material-ui/styles';
import TextField from 'material-ui/TextField';
import SourceDialog from './components/SourceDialog';
import MediumDialog from './components/MediumDialog';
import PublisherDialog from './components/PublisherDialog';
import Button from 'material-ui/Button';
import Snackbar from 'material-ui/Snackbar';
import Slide from 'material-ui/transitions/Slide';
import CopyToClipboard from 'react-copy-to-clipboard';

const styleSheet = createStyleSheet(theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,
  },
  button: {
    margin: theme.spacing.unit,
  },
}));

class App extends Component {
  state = {
    copied: false,
    open: false,
    direction: null,
  };

  handleChange = event => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    if (name === 'url') {
      const url = new URL(value);

      if (url.searchParams.get('amp') || /[?&]amp/.test(url.search)) {
        this.setState({
          amp: true,
        });
      }
    }
    console.log('Value: ' + value);
    console.log('Name: ' + name);
    this.setState({
      [name]: value,
    });
  };

  handleClick = direction => () => {
    this.setState({ open: true, direction });
  };

  handleRequestClose = () => {
    this.setState({ open: false });
  };

  getCampaignSource = source => {
    this.setState({ source });
  };

  getCampaignMedium = medium => {
    this.setState({ medium });
  };

  getCampaignPublisher = publisher => {
    this.setState({ publisher: publisher });
  };

  constructFinalLink = (
    url,
    sourceprefix,
    source,
    fbpage,
    mediumprefix,
    medium,
    campaignprefix,
    campaign,
    publisher,
    audience,
    termprefix,
    term,
    contentprefix,
    content,
    amp
  ) => {
    if (this.state.url === undefined) {
      return 'Die URL fehlt noch';
    } else {
      url = url + '?';
    }

    if (this.state.source === undefined) {
      return 'Die Quelle fehlt noch';
    }

    if (this.state.medium === undefined) {
      return 'Das Medium fehlt noch';
    }

    if (this.state.publisher === undefined) {
      return 'Der Publisher fehlt noch';
    }

    if (this.state.campaign === undefined) {
      return 'Der Kampagnenname fehlt noch';
    }

    const urisource = encodeURIComponent(source);
    const urifbpage = encodeURIComponent(fbpage);
    const urimedium = encodeURIComponent(medium);
    const uricampaign = encodeURIComponent(campaign);
    const uripublisher = encodeURIComponent(publisher);
    const uriaudience = encodeURIComponent(audience);
    const uriterm = encodeURIComponent(term);
    const uricontent = encodeURIComponent(content);
    // let new_url;
    // if (url && amp) {
    //   var newurl = new URL(url);
    //
    //   var query_string = newurl.search;
    //
    //   var search_params = new URLSearchParams(query_string);
    //
    //   // new value of "id" is set to "101"
    //   search_params.set('amp', '1');
    //   // search_params.delete('amp');
    //
    //   // change the search property of the main url
    //   newurl.search = search_params.toString();
    //
    //   // the new url string
    //   new_url = newurl.toString();
    //
    //   // output : http://demourl.com/path?id=101&topic=main
    //   console.log('new url: ' + new_url);
    // }

    return `${url}${sourceprefix}${urisource}${
      fbpage ? '_' + urifbpage : ''
    }${mediumprefix}${urimedium}${campaignprefix}${
      publisher ? uripublisher + '_' : ''
    }${uricampaign}${audience ? '_' + uriaudience : ''}${
      term ? termprefix : ''
    }${term ? uriterm : ''}${content ? contentprefix : ''}${
      content ? uricontent : ''
    }`;
  };

  render() {
    const classes = this.props.classes;

    const sourceprefix = 'utm_source=';
    const mediumprefix = '&utm_medium=';
    const campaignprefix = '&utm_campaign=';
    const termprefix = '&utm_term=';
    const contentprefix = '&utm_content=';

    const finallink = this.constructFinalLink(
      this.state.url,
      sourceprefix,
      this.state.source,
      this.state.fbpage,
      mediumprefix,
      this.state.medium,
      campaignprefix,
      this.state.campaign,
      this.state.publisher,
      this.state.audience,
      termprefix,
      this.state.term,
      contentprefix,
      this.state.content,
      this.state.amp
    );

    return (
      <div className={classes.container}>
        <TextField
          name="url"
          id="Hier den Link"
          label="URL"
          InputProps={{ placeholder: 'http://...' }}
          helperText="Link der zur Kampagne gemacht werden soll"
          fullWidth
          margin="normal"
          onChange={this.handleChange}
        />
        <SourceDialog onRequestClose={this.getCampaignSource} />
        <MediumDialog onRequestClose={this.getCampaignMedium} />
        <PublisherDialog onRequestClose={this.getCampaignPublisher} />

        {this.state.source === 'Facebook' ? (
          <TextField
            name="fbpage"
            id="Hier den Facebook Seitennamen eintragen"
            label="Name der Facebook Fanpage"
            InputProps={{ placeholder: 'OMGfunnyCatGIFs' }}
            helperText="Nur ausfüllen, wenn es sich nicht um die primäre FB-Page handelt"
            fullWidth
            margin="normal"
            onChange={this.handleChange}
          />
        ) : (
          ''
        )}
        <TextField
          name="campaign"
          id="Hier den Kampagnennamen eintragen"
          label="Name der Kampagne"
          InputProps={{ placeholder: 'Kampagne XYZ' }}
          helperText="Name und ggf. Art (bei Ads) der Kampagne"
          fullWidth
          margin="normal"
          onChange={this.handleChange}
        />
        <TextField
          name="audience"
          id="audience"
          label="Audience"
          InputProps={{ placeholder: 'Frauen zw. 18-55' }}
          helperText="(optional)"
          fullWidth
          margin="normal"
          onChange={this.handleChange}
        />
        <TextField
          name="term"
          id="term"
          label="Keywords (in AdWords)"
          InputProps={{ placeholder: '+musik +radio +stream ...' }}
          helperText="(optional bei Google Ads)"
          fullWidth
          margin="normal"
          onChange={this.handleChange}
        />
        <TextField
          name="content"
          id="content"
          label="Beschreibung des Ads"
          InputProps={{ placeholder: '' }}
          helperText="(optional, um Ads auseinander halten zu können)"
          fullWidth
          margin="normal"
          onChange={this.handleChange}
        />
        <TextField
          id="multiline-flexible"
          label="Finaler Kampagnen-Link"
          multiline
          rowsMax="4"
          fullWidth
          value={finallink}
          margin="normal"
        />
        <CopyToClipboard
          text={finallink}
          onCopy={() => this.setState({ copied: true })}
        >
          <Button
            raised
            color="primary"
            className={classes.button}
            onClick={this.handleClick('up')}
          >
            In Zwischenablage
          </Button>
        </CopyToClipboard>
        <Snackbar
          open={this.state.open}
          onRequestClose={this.handleRequestClose}
          transition={<Slide direction={this.state.direction} />}
          SnackbarContentProps={{
            'aria-describedby': 'message-id',
          }}
          message={<span id="message-id">Wurde kopiert</span>}
        />
      </div>
    );
  }
}

App.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styleSheet)(App);



// WEBPACK FOOTER //
// ./src/App.js